import { Search, FileText, Calculator, Users, ClipboardList, Palette, Send, ShieldCheck } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const PrivateInvestigationIndustry = () => (
  <IndustryPlaceholderPage
    name="Private Investigation"
    icon={Search}
    iconColor="text-success"
    iconBg="bg-[hsl(var(--success)/0.1)]"
    headline="Investigation Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps PI firms and investigators create professional case proposals, retainer agreements, and investigation contracts with speed and confidentiality."
    valueProps={[
      { title: "Scope Cases Faster", description: "Auto-generate investigation proposals with case type, estimated hours, methodology, and cost breakdowns — ready for client review." },
      { title: "Build Client Trust", description: "Professional, branded proposals with confidentiality clauses that demonstrate credibility and protect sensitive case information." },
      { title: "Built for Investigators", description: "Investigation-specific templates for surveillance, background checks, fraud cases, and due diligence — designed by industry professionals." },
    ]}
    features={[
      { icon: Calculator, label: "Retainer Calculators" },
      { icon: ClipboardList, label: "Case Scoping" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Send, label: "Digital Retainers" },
      { icon: ShieldCheck, label: "Confidentiality Built-In" },
      { icon: Users, label: "Multi-Investigator Access" },
      { icon: Palette, label: "Custom Branding" },
      { icon: Search, label: "Case Type Templates" },
    ]}
    benefits={[
      "Generate case-specific proposals with investigation scope and methodology",
      "Calculate estimated hours, travel costs, and retainer fees automatically",
      "Create branded proposals with confidentiality clauses built in",
      "Send retainer agreements with digital signature capture",
      "Track active cases, proposals, and client communications",
      "Support surveillance, background check, and due diligence case types",
    ]}
    proposalTemplates={[
      "Surveillance Investigation",
      "Background Check Services",
      "Insurance Fraud Investigation",
      "Corporate Due Diligence",
      "Missing Persons Investigation",
    ]}
    contractTemplates={[
      "Retainer Agreement",
      "Investigation Services Contract",
      "Confidentiality & Non-Disclosure",
      "Hourly Services Agreement",
    ]}
    faq={[
      { q: "What is Sentinel Forge for PI firms?", a: "Sentinel Forge is a proposal and contract automation platform. For investigators, it helps you create case proposals, calculate retainer fees, and send digital agreements — all while maintaining confidentiality." },
      { q: "Can I create proposals for different case types?", a: "Yes. The platform includes templates for surveillance, background checks, insurance fraud, corporate due diligence, missing persons, and more." },
      { q: "How does the retainer calculator work?", a: "You define your hourly rate, estimated case hours, travel expenses, and other costs. The system calculates the total retainer and generates a professional proposal with the breakdown." },
      { q: "Are proposals confidential?", a: "Yes. Every proposal and contract includes built-in confidentiality provisions. Client data is securely stored and never shared." },
      { q: "Can clients sign retainers digitally?", a: "Yes. Clients receive a secure link to review and digitally sign retainer agreements without needing to create an account." },
      { q: "Can I white-label my proposals?", a: "Yes. Your firm's logo, name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will the PI module be available?", a: "We're actively developing the investigation module. Join the waitlist and we'll notify you as soon as it launches." },
      { q: "How do I get support?", a: "Contact our team at support@sentinelforge.com or use the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to professionalize your case proposals?"
    ctaDescription="Join PI firms preparing to automate investigation proposals and retainer agreements with Sentinel Forge."
  />
);

export default PrivateInvestigationIndustry;
